<div class="top-bar">
    <div class="top-bar-content">
        <div class="page-info">
            <h2 class="page-title">Panel de Administración</h2>
        </div>
        <div class="top-bar-actions">
            <app-notification-bell></app-notification-bell>
            <div class="user-profile">
                <div class="user-avatar">
                    <span>{{ userInitials }}</span>
                </div>
                <div class="user-info">
                    <span class="user-name">{{ userName }}</span>
                    <span class="user-role">Administrador</span>
                </div>
            </div>
        </div>
    </div>
</div>